import React from 'react';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
const items = [{
  title: 'Programa Completo de Radiestesia Terapéutica - Nivel I',
  description: 'Aprendé a utilizar el péndulo, medir energía y aplicar protocolos de radiestesia con seguridad.',
  image: 'https://cdn.magicpatterns.com/uploads/vk8Gmm5YUJKsgCEjTsQQsd/0038b9c1-f171-4768-b693-2f41b14580b5.webp'
}, {
  title: 'Gráfico de las 36 Fuerzas - Nivel II',
  description: 'Herramienta y guía para revelar la naturaleza de la fuerza que actúa en el campo de energía.',
  image: 'https://cdn.magicpatterns.com/uploads/4JG9Kp2B8oJLX7hQAezTiA/e0b48c21-f236-4bc8-9b8c-1a018ce59ace.webp'
}, {
  title: 'Biómetro Radiestésico - Nivel III',
  description: 'Herramienta y guía para medir la intensidad vibracional y el nivel de energía vital.',
  image: 'https://cdn.magicpatterns.com/uploads/taQ3EBoicdXXoAQGiYe8Fq/300d7bee-78c6-4095-baa7-cd9da88c2db9.webp'
}, {
  title: 'Gráfico de Tratamiento Profesional',
  description: 'Herramienta y manual para guiarte sobre qué técnica utilizar para armonizar el campo energético.',
  image: 'https://cdn.magicpatterns.com/uploads/xcW13KiMv5PyNGMoSvadpQ/b4ed2270-b316-482c-80e1-856b2d0253b7.webp'
}, {
  title: 'Manual de Integración Profesional',
  description: 'Instrucciones paso a paso sobre cómo utilizar cada gráfico durante la sesión para un diagnóstico preciso.',
  image: 'https://cdn.magicpatterns.com/uploads/c23JvV7z5caQWqRHYmuWHa/93688b37-54a3-44f3-9d87-2d81d5b6fa78.webp'
}, {
  title: 'Guion de Sesión Radiestésica',
  description: 'Un modelo práctico para brindar servicio al cliente de principio a fin con mayor organización y seguridad.',
  image: 'https://cdn.magicpatterns.com/uploads/7pCrVLt7w99KGNsCepbEqG/6f74445e-ba03-43e7-af1a-a54776f5a095.webp'
}, {
  title: 'Checklist del Servicio Radiestesista',
  description: 'Guía paso a paso para una sesión completa: preparación, diagnóstico, causa, intensidad y tratamiento.',
  image: 'https://cdn.magicpatterns.com/uploads/8KhhLj8hukUJVu9ZK6LXh5/533c502d-2e4e-4b00-a30f-b43c57a24d5e.webp'
}, {
  title: '17 Protocolos de Radiestesia',
  description: 'Protocolos prácticos para apoyar la evaluación, investigación y armonización de la energía en diferentes contextos terapéuticos.',
  image: 'https://cdn.magicpatterns.com/uploads/3n2uj7eJXpnx5FKss1qCZZ/604dc573-297e-4e6c-8b5e-55726fd4bdca.webp'
}, {
  title: 'Fichas de Anamnesis para Radiestesia (Canva)',
  description: 'Una plantilla profesional y personalizable para registrar información esencial del cliente e iniciar la sesión con claridad energética.',
  image: 'https://cdn.magicpatterns.com/uploads/nxRHDDtcDhAzj1dvZfDvc8/a713d3b3-31c6-406c-81e5-4ed8fad2549c.webp'
}];
export function WhatYouReceive() {
  return <section className="py-24 bg-[#FFFBF2] relative overflow-hidden pt-[30px] pb-[30px]" data-id="element-436" data-mp="35wq0ew6m6h2j">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#F5F0FF] rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none opacity-60" data-id="element-437" data-mp="3av16qwxpa9g0" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#FCEFC7]/40 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2 pointer-events-none opacity-60" data-id="element-438" data-mp="31ve7ohsg1fq4" />

      <div className="max-w-5xl mx-auto px-4 relative z-10" data-id="element-439" data-mp="2n4nf37j12cly">
        <div className="text-center mb-16" data-id="element-440" data-mp="2ryi6yy8sdxw4">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-violet-100 text-violet-600 text-xs font-black uppercase tracking-widest mb-6" data-id="element-441" data-mp="2rzjggya5mcbq">
            <Sparkles size={14} data-id="element-442" data-mp="3bkwpy6yas68y" />
            <span data-id="element-443" data-mp="3bj3k2tvidq20">Tu Transformación Profesional</span>
          </motion.div>

          <h2 className="md:text-6xl text-violet-950 text-[32px] font-medium font-['Playfair_Display']" data-id="element-444" data-mp="37ijldlvaeedr">
            Aquí está todo lo que recibís <br className="hidden md:block" data-id="element-445" data-mp="32q8m8l8dewm9" />
            <span className="text-violet-600 italic" data-id="element-446" data-mp="2xti65xwkg10u">al acceder hoy</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-447" data-mp="2suezya4unora">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group p-6 rounded-3xl bg-[#F5F0FF]/60 border border-[#EDE4FF] hover:bg-[#FFFBF2] hover:shadow-xl hover:shadow-violet-200/30 transition-all duration-300" data-id="element-448" data-mp="2nuj5p2lyfbox" data-mpi={index}>
              {item.image && <div className="mb-6 overflow-hidden rounded-2xl" data-id="element-449" data-mp="pk27xscyfmpw">
                  <img src={item.image} alt={item.title} className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-450" data-mp="ubjxzldfw2w3" />
                </div>}
              <div className="flex items-start gap-4" data-id="element-451" data-mp="1pr3s067lwkx">
                <div className="shrink-0 mt-1" data-id="element-452" data-mp="6nk78lg4ochi">
                  <CheckCircle2 className="text-violet-600 group-hover:scale-110 transition-transform" size={24} data-id="element-453" data-mp="6oc37xdn0c8b" />
                </div>
                <div data-id="element-454" data-mp="fkukgcciabp2">
                  <h3 className="text-lg font-bold text-violet-950 mb-2 leading-tight" data-id="element-455" data-mp="1n10wn0rnkg0r">
                    {item.title}
                  </h3>
                  <p className="text-violet-800/70 text-sm leading-relaxed" data-id="element-456" data-mp="1r0rkavlvug12">
                    {item.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-16 p-8 rounded-[2.5rem] bg-gradient-to-br from-[#F9E29C] via-[#FCEFC7] to-[#E9DDFF] text-violet-950 text-center shadow-2xl shadow-violet-100 border border-white/60" data-id="element-457" data-mp="3j68cwx46ijdx">
          <p className="text-xl md:text-2xl font-medium italic" data-id="element-458" data-mp="3s2hb68gf7byh">
            "No es solo una guía, es el sistema operativo de tu nueva vida como
            terapeuta profesional de Radiestesia."
          </p>
        </div>
      </div>
    </section>;
}